/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Failed_Fork_RefInputs */



/**
* | output |
* | --- |
* | "our archive fork could not be read" |
*
* @param {Twda_Failed_Fork_RefInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_failed_fork_ref = /** @type {((inputs?: Twda_Failed_Fork_RefInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Failed_Fork_RefInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("notre fork de l'archive n'a pas pu être lu")
	if (locale === "es") return /** @type {LocalizedString} */ ("nuestro fork del archivo no se pudo leer")
	if (locale === "pt") return /** @type {LocalizedString} */ ("nosso fork do arquivo não pôde ser lido")
	if (locale === "it") return /** @type {LocalizedString} */ ("il nostro fork dell'archivio non è stato letto")
	return /** @type {LocalizedString} */ ("our archive fork could not be read")
});